import { Injectable } from '@angular/core';


import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formconfig } from '../../configuration/formconfig/formconfig';
import { environment } from '../../../environments/environment';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class FormdashboardgrouptableService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  
  getDocumentStatus(formdata: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getDocumentStatus/' + formdata);
  };
    
  //getAllFormDocumentDetails(formconfigid: number, pageno: number, searchcondition: string): Observable<any> {
  //  return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetails/' + formconfigid + '/' + pageno + '/' + searchcondition);
  //}

  getAllFormDocumentDetails(obj: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetails', obj, { headers: header, observe: 'response' });
  }

  getAllFormDocumentDetailscount(obj: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetailscount', obj, { headers: header, observe: 'response' });
  }
  getformsearchdetailsfieldname(formconfid: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getformsearchdetailsfieldname/' + formconfid, { headers: header, observe: 'response' });
  }

}
